<template>
  <div class="dataAnalysis">
    <div class="test-map">
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="handleClick(item)"
        class="btn"
        :class="active === item.id ? 'active' : ''"
      >
        {{ item.title }}
      </div>
    </div>
    <component :is="listcomponent" :cpn="listcomponent"> </component>
  </div>
</template>
<script>
import { defineComponent, ref, reactive, toRefs, provide } from "vue";
import HousingAnalysis from "./housingAnalysis/housingAnalysis.vue";
import PopulationAnalysis from "./populationAnalysis/populationAnalysis.vue";
import UnitOfAnalysis from "./unitOfAnalysis/unitOfAnalysis.vue";
import EventAnalysis from "./eventAnalysis/eventAnalysis.vue";
import WarningAnalysis from "./warningAnalysis/warningAnalysis.vue";
import TrafficAnalysis from "./trafficAnalysis/trafficAnalysis.vue";
export default defineComponent({
  name: "",
  components: {
    HousingAnalysis,
    PopulationAnalysis,
    UnitOfAnalysis,
    EventAnalysis,
    WarningAnalysis,
    TrafficAnalysis,
  },
  props: {},
  setup(props) {
    const list = reactive([
      { id: 0, title: "人口分析", conponent: "PopulationAnalysis" },
      { id: 1, title: "房屋分析", conponent: "HousingAnalysis" },
      { id: 2, title: "单位分析", conponent: "UnitOfAnalysis" },
      { id: 3, title: "事件分析", conponent: "EventAnalysis" },
      // { id: 4, title: "告警分析", conponent: "WarningAnalysis" },
      { id: 5, title: "车辆分析", conponent: "TrafficAnalysis" },
    ]);
    const carlist = reactive([
      { id: 0, title: "实有车辆", num: 3334 },
      { id: 1, title: "实有车辆", num: 3334 },
      { id: 2, title: "实有车辆", num: 3334 },
      { id: 3, title: "实有车辆", num: 3334 },
      { id: 4, title: "实有车辆", num: 3334 },
      { id: 5, title: "实有车辆", num: 3334 },
      { id: 6, title: "实有车辆", num: 3334 },
      { id: 7, title: "实有车辆", num: 3334 },
    ]);
    const state = reactive({
      listcomponent: "PopulationAnalysis",
    });

    const active = ref(0); // 按钮索引值

    const handleClick = (item) => {
      active.value = item.id;
      state.listcomponent = item.conponent;
    };
    provide("active", active);
    return { list, handleClick, active, carlist, ...toRefs(state) };
  },
});
</script>
<style lang="scss" scoped>
.dataAnalysis {
  background: url("~@/assets/images/threeSolid/threebg.png");
  height: 100%;
  width: 100%;
  position: relative;
  .test-map {
    position: absolute;
    top: 2%;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    color: #fff;
    z-index: 10;
    button {
      border: none;
    }
  }
  .car {
    z-index: 3;
    width: 1050px;
    height: 210px;
    background-image: url("~@/assets/images/0303/box.png");
    background-repeat: no-repeat;
    position: absolute;
    bottom: -100px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 100px;
    .itemcard {
      margin-right: 15px;
      width: 165px;
      height: 70px;

      background-image: url("~@/assets/images/0303/cardbg.png");
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .itemcardtitle {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
      }
      .itemcardnum {
        color: #23fffc;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .selectarea {
    background-color: rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    position: absolute;
    bottom: 195px;
    left: 39%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 5;
    padding: 10px;
    box-sizing: border-box;
    ::v-deep .el-select {
      margin-right: 15px !important;
    }
    .selectareaitme {
      z-index: 5;
    }
    ::v-deep .el-input__inner {
      background-color: #065080 !important;
      outline: none !important;
      border: none !important;
      input {
        background-color: #065080 !important;
      }
    }
  }
  .btn {
    cursor: pointer;
    position: relative;
    color: #fff;
    width: 140px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: rgba(255, 255, 255, 0);
    background-image: url("~@/assets/images/0303/menu2.png");
    background-repeat: no-repeat;
    margin: 0 5px;
    &.active {
      color: #fff;
      width: 140px;
      height: 50px;
      background-color: rgba(255, 255, 255, 0);
      background-image: url("~@/assets/images/0303/menu1.png");
      background-repeat: no-repeat;
    }
  }
  .cqmap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
  }
  .home-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .home-left {
      pointer-events: auto;
    }
  }
}
</style>
